import type { MatchRules } from "./ability";
import type { SimEvent } from "./events";
import { setState } from "./transition";
import { createFighter, emptyShot, FIGHTER, PHASE, type MatchState } from "./state";

export const INTRO_FRAMES = 100;
export const FIGHT_CALL_FRAMES = 40;
export const KO_FRAMES = 200;

function startRound(state: MatchState, rules: MatchRules, events: SimEvent[]): void {
  const before = state.fighters;
  state.fighters = [createFighter(rules, 0), createFighter(rules, 1)];
  state.shots = [emptyShot(), emptyShot()];
  // новый раунд — решающий удар снова возможен
  state.slowmo = 0;
  state.slowTick = 0;
  state.slowBits = [0, 0];
  state.slowmoDone = 0;
  state.slowmoBy = -1;
  state.fighters.forEach((fighter, side) => {
    const old = before[side as 0 | 1];
    fighter.wins = old.wins;
    if (rules.meter.carryOver) fighter.meter = old.meter;
  });
  state.phase = PHASE.intro;
  state.phaseFrame = 0;
  state.timer = rules.roundSeconds * 60;
  state.winner = -1;
  state.hitstop = 0;
  events.push({ kind: "roundStart", frame: state.frame, who: -1, x: 0, y: 0, strength: state.round });
}

function finishRound(state: MatchState, winner: number, phase: number, events: SimEvent[]): void {
  state.phase = phase;
  state.phaseFrame = 0;
  state.winner = winner;
  const champion = winner === 0 || winner === 1 ? state.fighters[winner] : null;
  if (champion) champion.wins++;
  events.push({ kind: "ko", frame: state.frame, who: winner, x: 0, y: 0, strength: phase === PHASE.timeUp ? 0 : 2 });
}

/** Фазы раунда: заставка → бой → нокаут или время → следующий раунд или конец матча. */
export function updateRound(state: MatchState, rules: MatchRules, events: SimEvent[]): void {
  state.phaseFrame++;
  const [a, b] = state.fighters;
  switch (state.phase) {
    case PHASE.intro:
      if (state.phaseFrame === 1 && state.frame === 1)
        events.push({ kind: "roundStart", frame: state.frame, who: -1, x: 0, y: 0, strength: state.round });
      if (state.phaseFrame >= INTRO_FRAMES) {
        state.phase = PHASE.fight;
        state.phaseFrame = 0;
        events.push({ kind: "fight", frame: state.frame, who: -1, x: 0, y: 0, strength: 0 });
      }
      break;
    case PHASE.fight:
      state.timer = Math.max(0, state.timer - 1);
      if (a.health === 0 || b.health === 0)
        finishRound(state, a.health === 0 && b.health === 0 ? -1 : a.health === 0 ? 1 : 0, PHASE.ko, events);
      else if (state.timer === 0)
        finishRound(state, a.health === b.health ? -1 : a.health > b.health ? 0 : 1, PHASE.timeUp, events);
      break;
    case PHASE.ko:
    case PHASE.timeUp: {
      const champion = state.winner === 0 || state.winner === 1 ? state.fighters[state.winner] : null;
      if (champion && state.phaseFrame === 70 && champion.state !== FIGHTER.ko) setState(champion, FIGHTER.victory);
      if (state.phaseFrame >= KO_FRAMES) {
        if (a.wins >= rules.roundsToWin || b.wins >= rules.roundsToWin) {
          state.phase = PHASE.matchEnd;
          state.phaseFrame = 0;
          events.push({ kind: "matchEnd", frame: state.frame, who: a.wins > b.wins ? 0 : 1, x: 0, y: 0, strength: 0 });
        } else {
          state.round++;
          startRound(state, rules, events);
        }
      }
      break;
    }
    default:
      break;
  }
}
